import { useEffect } from "react";
import { useUser } from "@clerk/clerk-react";
import { Sentry } from "@/lib/sentry";

/**
 * Syncs the authenticated Clerk user into Sentry's user context so that
 * error reports are associated with a specific user identity.
 * Must render inside <ClerkProvider>.
 */
export function SentryUserSync() {
  const { user, isLoaded } = useUser();

  useEffect(() => {
    if (!isLoaded) return;

    if (user) {
      Sentry.setUser({
        id: user.id,
        email: user.primaryEmailAddress?.emailAddress,
        username: user.username ?? undefined,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [user, isLoaded]);

  return null;
}
